import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import { Button } from '@/common/ui/button'
import showErrorToast from '@/common/utils/showErrorToast'
import useMutationDeleteLoginAnnouncement from '@/modules/client-setting/api/hooks/useMutationDeleteLoginAnnouncement'
import { LoginAnnouncementQueryKeys } from '@/modules/client-setting/keys'
import { useQueryClient } from '@tanstack/react-query'
import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'

interface DeleteLoginAnnounceProps {
	id: string
}

export default function DeleteLoginAnnounce({ id }: DeleteLoginAnnounceProps) {
	const queryClient = useQueryClient()
	const { mutate: deleteLoginAnnounce, isPending } =
		useMutationDeleteLoginAnnouncement({
			onSuccess: () => {
				toast.success('ลบประกาศสำเร็จ')
				queryClient.invalidateQueries({
					queryKey: [LoginAnnouncementQueryKeys.GetLoginAnnouncement],
				})
			},
			onError: (error) => {
				showErrorToast(error)
			},
		})

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Trash2 className="size-4 text-destructive" />
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>ยืนยันการลบประกาศ</AlertDialogTitle>
					<AlertDialogDescription>
						คุณต้องการลบประกาศนี้ใช่หรือไม่?
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter className="gap-2">
					<AlertDialogCancel disabled={isPending}>ยกเลิก</AlertDialogCancel>
					<AlertDialogAction
						disabled={isPending}
						onClick={() => deleteLoginAnnounce({ id })}
						className="bg-destructive hover:bg-destructive/90"
					>
						{isPending ? 'กำลังลบ...' : 'ยืนยัน'}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
